import { Box, Spinner } from '@chakra-ui/react'
import { useAuthContext } from 'contexts/auth'
import jwt_decode from 'jwt-decode'
import { AuthTokens } from 'models'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { hasPermission } from 'utils/permissions/PermissionGate'
import { permissions } from 'utils/permissions/permissionsMap'
import Agree from './components/Agree'

export default function PrivateRouting() {
    const { currentUser } = useAuthContext()
    const { pathname } = useLocation()
    const decodedIdToken =
        currentUser && (jwt_decode(currentUser?.idToken) as AuthTokens)

    const pathNameFormatterd = '/' + pathname.split('/')[1]

    const { loadingAuth } = useAuthContext()

    const switchAuth: { [key: string]: string } = {
        '/instituicoes': permissions.instituicao.leitura,
        '/usuarios': permissions.usuario.leitura,
        '/agentes-financeiros': permissions.af.leitura,
        '/contratos': permissions.contrato.leitura,
        '/consulta-contratos': permissions.contrato.leitura,
        '/relatorio': permissions.relatorio.leitura,
        '/gestao-taxas': permissions.gestaoTaxas.leitura,
        '/comunicacao': permissions.relatorio.leitura,
        '/alterar-senha': permissions.contrato.leitura,
        '/relatorio-financeiro': permissions.gestaoTaxas.leitura,
        '/relatorio-gestao': permissions.gestaoTaxas.leitura,
        '/veiculos': permissions.contrato.leitura
    }

    const authJWT = hasPermission([switchAuth[pathNameFormatterd]])

    return currentUser ? (
        <>
            {!loadingAuth ? (
                authJWT ? (
                    <>
                        <Agree />
                        <Outlet />
                    </>
                ) : decodedIdToken?.UFDetran ? (
                    <Navigate to="/relatorio" />
                ) : (
                    <Navigate to="/contratos" />
                )
            ) : (
                <Box height="100vh">
                    <Spinner
                        size="xl"
                        speed="1s"
                        position="absolute"
                        top="calc(50% - 33px)"
                        left="calc(50% - 33px)"
                    />
                </Box>
            )}
        </>
    ) : (
        <Navigate to="/entrar" />
    )
}
